import { __rest } from "tslib";
import React, { useRef, useState, useEffect } from 'react';
import LxPopover from '@web-common/components/UI/LxPopover/LxPopover';
import { apiHolder as api, getIn18Text } from 'api';
import classnames from 'classnames';
import style from './editor.module.scss';
const Arial = getIn18Text('SIYUANHEITI');
const fontFormats = `微软雅黑=Microsoft YaHei,微软雅黑;隶书=LiSu,隶书;幼圆=YouYuan,幼圆;Calibri=Calibri;${Arial}Arial Black=arial black,avant garde;Times New Roman=times new roman,times;Verdana=verdana,geneva;Lucida Grande=lucida grande;Menlo=menlo`;
const defaultFontFamilys = fontFormats.split(';').map(item => {
    const itemAry = item.split('=');
    return { name: itemAry[0], value: itemAry[1] };
});
const storeApi = api.api.getDataStoreApi();
const HOCFontFamily = (Component) => {
    const EdFontFamily = (props) => {
        const { ref, onEditCreated } = props, rest = __rest(props, ["ref", "onEditCreated"]);
        const [editorInstance, seteditorInstance] = useState(null);
        const [visible, setVisible] = useState(false);
        const [selectFontFamily, setSelectFontFamily] = useState('');
        const [defaultFontFamily, setDefaultFontFamily] = useState('Source Han Sans');
        const [tipPos, setTipPos] = useState({
            top: 0,
            left: 0,
        });
        const setVisibleRef = useRef(setVisible);
        const setTipPosRef = useRef(setTipPos);
        setVisibleRef.current = setVisible;
        setTipPosRef.current = setTipPos;
        const fontfamilyAction = button => {
            let elem = document.querySelector('.tox-tbtn--lx-fontfamily-btn');
            while (elem) {
                if (elem.className.includes('tox-toolbar__group')) {
                    break;
                }
                elem = elem.parentElement;
            }
            const elemRect = elem.getBoundingClientRect();
            setVisibleRef.current(true);
            setTipPosRef.current({
                top: elemRect.top + 40,
                left: elemRect.left,
            });
        };
        const editorSetup = ed => {
            seteditorInstance(ed);
            onEditCreated(ed);
        };
        useEffect(() => {
            if (visible && editorInstance) {
                const fontFamily = editorInstance.queryCommandValue('FontName');
                setSelectFontFamily(fontFamily);
            }
        }, [visible]);
        useEffect(() => {
            setDefaultFontFamily(storeApi.getSync('defaultFontFamily').data || 'Source Han Sans');
        }, []);
        const setDefaultFontFamilyCl = () => {
            if (defaultFontFamilys.every(i => i.value !== selectFontFamily))
                return;
            storeApi.put('defaultFontFamily', selectFontFamily);
            setDefaultFontFamily(selectFontFamily);
        };
        const selectFontFamilyCl = fontFamily => {
            const value = fontFamily.value;
            if (!editorInstance)
                return;
            setSelectFontFamily(value);
            editorInstance.execCommand('FontName', false, value);
            setVisible(false);
        };
        return (React.createElement(React.Fragment, null,
            React.createElement(Component, Object.assign({}, rest, { ref: ref, fontfamilyAction: fontfamilyAction, onEditCreated: editorSetup })),
            React.createElement(LxPopover, { top: tipPos.top, left: tipPos.left, resetStyle: { zIndex: 999 }, visible: visible, setVisible: setVisible, acceptTopBottom: true },
                React.createElement("div", { className: classnames(style.fontFamilyBoxWrap, style.fontCommaBoxWrap) },
                    React.createElement("div", { className: classnames(style.fontFamilyBox) }, defaultFontFamilys.map(font => (React.createElement("div", { className: classnames([style.fontFamilyItem, font.value === selectFontFamily && style.fontCommaSelected]), style: { fontFamily: font.value }, onClick: () => {
                            selectFontFamilyCl(font);
                        } },
                        font.name,
                        font.value === defaultFontFamily && React.createElement("span", { className: style.fontDefault }, "\u9ED8\u8BA4"))))),
                    React.createElement("div", { className: classnames(style.setDefaultCol, defaultFontFamilys.every(i => i.value !== selectFontFamily) && 'disabled'), onClick: setDefaultFontFamilyCl }, getIn18Text('JIANGDANGQIANZTSWMR'))))));
    };
    return React.forwardRef((props, ref) => React.createElement(EdFontFamily, Object.assign({}, props, { ref: ref })));
};
export default HOCFontFamily;
